/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-08-20 11:21:32
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-10 15:23:34
 * @FilePath: \senlan-ai-ui\src\pages\ChatPage\components\input.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useRef, useState } from 'react'
import {
  Input,
  Button,
  Tooltip,
  message,
  Dropdown,
  Menu,
  Space,
  Select,
} from 'antd'
import LoadingButton from './subBut'
import { useStyle } from '../style'
import { useConversationContext } from '../../../stores/conversation.store'
import { useMatch } from 'react-router-dom'
import { actionButtonConfig } from '../../../const'
import { CheckOutlined, PictureOutlined } from '@ant-design/icons'
import { imageConfigAtom, configList } from '../../../stores/imageAtom.tsx'
import { atom, useAtom } from 'jotai'
import img_gray from '@/assets/icon/AI／icon／img_gray.png'
import InputFileCard from '@/pages/components/InputFileCard/index.tsx'
import { uploadFile, deleteFile, submitFiles } from '@/api/doc'
interface UploadedFile {
  id: string
  name: string
  type: string // 'image' | 'file'
  status: 'uploading' | 'success' | 'error',
  size?: string
  url?: string
}
interface ChatInputProps {
  inputValue: string
  onInputChange: (value: string) => void
  onSubmit: (value: string, imageUrls: string[], fileUrls: any[]) => void
  isLoading: boolean
  isActionButton?: boolean
  placeholder?: string
  isImage?: boolean
}

const ChatInput: React.FC<ChatInputProps> = ({
  inputValue,
  onInputChange,
  onSubmit,
  isLoading,
  isActionButton,
  isImage,
  placeholder = '输入一条信息，开启Hi.AI',
}) => {
  const { styles } = useStyle()
  const [activeButton, setActiveButton] = useState<string | null>(null)
  const [fileList, setFileList] = useState<UploadedFile[]>([
    // {
    //   id: '1',
    //   name: '产品设计图_最终版_2024.png',
    //   size: 1024 * 1024 * 1.2, // 1.2MB
    //   type: 'image/png',
    //   url: 'https://picsum.photos/200/300', // 随机图片地址
    //   status: 'done',
    // },
    // {
    //   id: '2',
    //   name: '2024年第一季度财务报表分析.pdf',
    //   size: 1024 * 512, // 512KB
    //   type: 'application/pdf',
    //   status: 'done',
    // },
    // {
    //   id: '3',
    //   name: '项目进度跟踪表(由于名字太长会被隐藏后缀显示).xlsx',
    //   size: 1024 * 24, // 24KB
    //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //   status: 'done',
    // },
    // {
    //   id: '4',
    //   name: '正在上传的文档.docx',
    //   size: 1024 * 128,
    //   type: 'application/msword',
    //   status: 'uploading', // 会触发你写的 3s 进度条逻辑
    // },

  ])
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1000)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const [isDragging, setIsDragging] = useState(false);
  const { aiCapabilities, toggleCapability } = useConversationContext()
  const [config, setConfig] = useAtom(imageConfigAtom)
  const handleMouseEnter = (key: string) => setActiveButton(key)
  const handleMouseLeave = () => setActiveButton(null)
  const isGroup = useMatch('/chat/*')
  const isRag = useMatch('/rag_chat/*')

  const isChat = isGroup || isRag
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // 只有当离开的是最外层容器时才关闭遮幕
    if (e.currentTarget === e.target) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false); // 放置后关闭遮幕
    uploadFileFun(e.dataTransfer.files);
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    uploadFileFun(e.target.files)
  };
  const handleRemove = (id: string, url: string) => {
    setFileList(prev => prev.filter(item => item.id !== id));
    deleteFile(url)
  };
  const uploadFileFun = async (files: any) => {
    if (!files || files.length === 0) return;

    // 文件数量限制
    const MAX_FILE_COUNT = 1;
    const currentFileCount = fileList.length;
    if (currentFileCount + files.length > MAX_FILE_COUNT) {
      message.error(`最多只能上传 ${MAX_FILE_COUNT} 个文件，当前已上传 ${currentFileCount} 个`);
      return;
    }

    const fileArray = Array.from(files);

    const MAX_FILE_SIZE = 100 * 1024;
    const oversizedFiles = fileArray.filter((file: any) => file.size > MAX_FILE_SIZE);
    if (oversizedFiles.length > 0) {
      message.error(`文件大小太大，请检查以下文件：${oversizedFiles.map((f: any) => f.name).join('、')}`);
      return;
    }

    // 1. 先在界面上显示“上传中”状态
    const tempFiles: UploadedFile[] = fileArray.map((file: any) => ({
      id: Math.random().toString(36).slice(2),
      name: file.name,
      type: file.type,
      status: 'uploading',
    }));

    setFileList(prev => [...prev, ...tempFiles]);

    // 2. 循环上传并更新状态
    for (let i = 0; i < fileArray.length; i++) {
      try {
        const res = await uploadFile(fileArray[i]);

        setFileList(prev => prev.map(item =>
          item.id === tempFiles[i].id
            ? {
              ...item, url: res.data, status: 'success', name: res.extra.fileName, size: res.extra.fileSize
            }
            : item
        ));
      } catch (error) {
        message.error(`${fileArray[i].name} 上传失败`);
        setFileList(prev => prev.map(item =>
          item.id === tempFiles[i].id ? { ...item, status: 'error' } : item
        ));
      }
    }
    if (aiCapabilities.onlineSearch) { toggleCapability('onlineSearch') }
    if (aiCapabilities.deepThink) { toggleCapability('deepThink') }
    if (fileInputRef.current) fileInputRef.current.value = '';
  }
  const handleInternalSubmit = () => {
    // 1. 过滤出上传成功的文件
    const successfulFiles = fileList.filter(item => item.status === 'success');

    // 2. 区分图片（image/*）和其他文件，并只保留 url 字符串数组
    const imageUrls = successfulFiles
      .filter(file => file.type.startsWith('image/') && file.url)
      .map(file => file.url!);

    const fileUrls = successfulFiles
      .filter(file => !file.type.startsWith('image/') && file.url)
      .map(file => ({
        "docName": file.name,
        "docSize": file.size,
        "docUrl": file.url
      }));

    // 3. 将处理后的数据传给父组件
    // 注意：这里需要确保父组件的 onSubmit 接口已同步更新
    onSubmit(inputValue, imageUrls, fileUrls);

    // 4. 清空状态
    setFileList([]);

  };

  const renderSelector = (item: (typeof configList)[number]) => {
    if (item.type === 'menu') {
      const menu = (
        <Menu
          onClick={(e) => setConfig({ ...config, [item.key]: e.key })}
          items={item.options.map((opt) => ({
            key: opt.value,
            label: (
              <Space>
                <span>{opt.label}</span>
                {config[item.key] === opt.value && (
                  <CheckOutlined style={{ color: '#1677ff' }} />
                )}
              </Space>
            ),
          }))}
        />
      )
      return (
        <Dropdown key={item.key} overlay={menu} trigger={['click']}>
          <Button>
            {item.icon}
            {item.label}
            {/* {item.options.find((o) => o.value === config[item.key])?.label ??
              '请选择'} */}
          </Button>
        </Dropdown>
      )
    }

    // Select 类型
    if (item.type === 'select') {
      return (
        <Select
          key={item.key}
          value={config[item.key] as number}
          onChange={(val) => setConfig({ ...config, [item.key]: val })}
          options={item.options}
        />
      )
    }

    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
      }}
    // onDragEnter={handleDragEnter}
    // onDragOver={handleDragOver}
    // onDragLeave={handleDragLeave}
    // onDrop={handleDrop}
    >
      <div
        style={{
          minHeight: 120,
          maxHeight: 240,
          border: isDragging ? '1px solid #3363FF' : '1px solid #E9EBEF', // 拖拽时边框变色
          borderRadius: 12,
          width: '100%',
          margin: '0 20px 24px 20px',
          display: 'flex',
          flexDirection: 'column',
          transition: 'all 0.2s ease-in-out',
          boxShadow: isDragging ? '0px 0px 15px 0px rgba(51, 99, 255, 0.2)' : '0px 0px 12px 0px #DEE1E6',
          maxWidth: 1000,
          padding: '10px',
          position: 'relative', // 遮幕的直接父级
          overflow: 'hidden', // 确保遮幕圆角不溢出
        }}
      >
        {/* 3. 新增遮幕组件 */}
        {isDragging && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              zIndex: 10,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 12,
              border: '2px dashed #3363FF',
              pointerEvents: 'none', // 关键：防止遮幕干扰 dragLeave 事件
            }}
          >
            <PictureOutlined style={{ fontSize: 32, color: '#3363FF', marginBottom: 8 }} />
            <span style={{ color: '#3363FF', fontSize: 16, fontWeight: 500 }}>
              释放文件以上传
            </span>
          </div>
        )}

        {fileList.length > 0 && (
          <div
            style={{
              padding: '0 10px',
            }}
          >
            {fileList.map((file) => (
              <InputFileCard
                key={file.id}
                file={file}
                onDelete={() => handleRemove(file.id, file.url)}
              />
            ))}
          </div>
        )}
        <Input.TextArea
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => onInputChange(e.target.value)}
          onPressEnter={(e) => {
            if (!e.shiftKey) {
              e.preventDefault()
              handleInternalSubmit()
            }
          }}
          rows={4}
          allowClear
          autoSize={{ minRows: 4 }}
          style={{
            border: 'none',
            maxHeight: 300,
            overflowY: 'auto',
            boxShadow: 'none',
            borderColor: '#f0f0f0',
            fontSize: '14px',
            color: '#313133',
          }}
        />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              height: '40px',
            }}
          >
            {isChat && (
              <div className={styles.actionButtons}>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept="image/*"
                  multiple
                  onChange={handleFileChange}
                />
                {/* <Tooltip title="上传图片">
                  {' '}
                  <Button
                    type="text"
                    icon={
                      <img
                        src={img_gray}
                        alt=""
                        style={{ width: 24, height: 24 }}
                      />
                    }
                    style={{
                      width: '40px',
                      height: '40px',
                      background: '#F6F8FA',
                      borderRadius: '8px',
                    }}
                    onClick={() => fileInputRef.current?.click()}
                  ></Button>
                </Tooltip> */}
                {isActionButton && fileList.length == 0 &&
                  actionButtonConfig?.map((button) => {
                    const isActive =
                      aiCapabilities[button.key as keyof typeof aiCapabilities]

                    return (
                      <Tooltip
                        key={button.key}
                        title={button.tipTitle}
                        color={button.baseColor}
                        open={activeButton === button.key}
                      >
                        <div
                          onMouseEnter={() => handleMouseEnter(button.key)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <Button
                            type="text"
                            style={{
                              color: isActive ? '#3363FF' : button.baseColor,
                              background: isActive
                                ? button.activeColor
                                : button.bgColor,
                              height: '40px',
                              borderRadius: '8px',
                              fill: isActive ? '#3363FF' : button.baseColor,
                            }}
                            onClick={() => {
                              toggleCapability(
                                button.key as keyof typeof aiCapabilities
                              )
                            }}
                          >
                            {button.icon}
                            {!isMobile && button.label}
                          </Button>
                        </div>
                      </Tooltip>
                    )
                  })}
              </div>
            )}
            {isImage && configList.map(renderSelector)}
          </div>

          <LoadingButton
            isLoading={isLoading}
            inputValue={inputValue}
            onClick={handleInternalSubmit}
          />
        </div>
      </div>
    </div>
  )
}

export default ChatInput
